import React from 'react';
import { Grid } from '@mui/material';

import { ContainerColumnLeft, InfoField } from '@occc-app/design-system';

import { CardLayout } from '@occc/ui-design-system';
import { getFulfilledInfo } from './getFulfilledInfo';

import { Fulfillment as AudienceOfferFulfillment } from '../../types';

interface FulfillmentsProps {
  fulfillments: AudienceOfferFulfillment[];
}

export const Fulfillments: React.FC<FulfillmentsProps> = ({ fulfillments }) => {
  return (
    <ContainerColumnLeft>
      <CardLayout title='Fulfillment'>
        {fulfillments.map(({ fulfilled, targetOffer, operator, timesFulfilled }, index) => {
          return (
            <Grid container spacing={3} key={index}>
              <Grid item xs={12} sm={6} md={4}>
                <InfoField
                  label='Fulfilled'
                  value={
                    fulfilled ? getFulfilledInfo(operator, timesFulfilled) : 'Has not fulfilled'
                  }
                  noDataMessage='Is not specified'
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoField
                  label='Target Offer Name'
                  value={targetOffer?.name}
                  noDataMessage='Is not specified'
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InfoField
                  label='Target Offer Id'
                  value={targetOffer?.id}
                  noDataMessage='Is not specified'
                />
              </Grid>
            </Grid>
          );
        })}
      </CardLayout>
    </ContainerColumnLeft>
  );
};
